import React, { useState } from 'react';
import classes from './read-more.module.scss';
const ReadMore = (props: { text: string; size: number }) => {
  const { text, size } = props;
  const [readMore, setReadMore] = useState(true);
  return (
    <div className={classes.readMore}>
      {text && text.length > size && readMore ? (
        <p>
          {text.slice(0, size) + '...'}
          <span
            className={classes.readMore}
            onClick={() => {
              setReadMore(!readMore);
            }}
          >
            Читати більше
          </span>
        </p>
      ) : (
        <p>{text}</p>
      )}
    </div>
  );
};

export default ReadMore;
